module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/bankcreation-grid/bankcreation-grid.component.css
// module id = ./src/app/masters/bankcreation-grid/bankcreation-grid.component.css
// module chunks = main